import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { AuthProvider } from "@/context/AuthContext";
import { Toaster } from "@/components/ui/sonner";
import ProtectedRoute from "@/components/ProtectedRoute";
import Layout from "@/components/Layout";
import AuthPage from "@/pages/AuthPage";
import AuthCallback from "@/pages/AuthCallback";
import Dashboard from "@/pages/Dashboard";
import CreateRequest from "@/pages/CreateRequest";
import RequestsList from "@/pages/RequestsList";
import RequestDetail from "@/pages/RequestDetail";
import DirectoryPage from "@/pages/DirectoryPage";
import CompanyProfile from "@/pages/CompanyProfile";
import PackageLabels from "@/pages/PackageLabels";
import Docs from "@/pages/Docs";
import AuditLog from "@/pages/AuditLog";
import Billing from "@/pages/Billing";
import { BillingSuccess, BillingCancel } from "@/pages/BillingResult";
import BillingGate from "@/components/BillingGate";

// A protected + gated wrapper for authenticated app pages.
const Guarded = ({ children }) => (
  <ProtectedRoute><BillingGate><Layout>{children}</Layout></BillingGate></ProtectedRoute>
);

function AppRoutes() {
  const location = useLocation();
  // Detect OAuth callback via URL fragment (must be synchronous)
  if (location.hash?.includes("session_id=")) return <AuthCallback />;

  return (
    <Routes>
      <Route path="/login" element={<AuthPage mode="login" />} />
      <Route path="/register" element={<AuthPage mode="register" />} />
      <Route path="/auth/callback" element={<AuthCallback />} />
      <Route path="/billing/success" element={<ProtectedRoute><BillingSuccess /></ProtectedRoute>} />
      <Route path="/billing/cancel" element={<ProtectedRoute><BillingCancel /></ProtectedRoute>} />
      <Route path="/billing" element={<ProtectedRoute><Layout><Billing /></Layout></ProtectedRoute>} />
      <Route path="/" element={<Guarded><Dashboard /></Guarded>} />
      <Route path="/dashboard" element={<Guarded><Dashboard /></Guarded>} />
      <Route path="/requests/new" element={<Guarded><CreateRequest /></Guarded>} />
      <Route path="/requests/:id/labels" element={<ProtectedRoute><BillingGate><PackageLabels /></BillingGate></ProtectedRoute>} />
      <Route path="/requests/:id" element={<Guarded><RequestDetail /></Guarded>} />
      <Route path="/requests" element={<Guarded><RequestsList /></Guarded>} />
      <Route path="/suppliers" element={<Guarded><DirectoryPage kind="supplier" /></Guarded>} />
      <Route path="/couriers" element={<Guarded><DirectoryPage kind="courier" /></Guarded>} />
      <Route path="/company" element={<Guarded><CompanyProfile /></Guarded>} />
      <Route path="/docs" element={<Guarded><Docs /></Guarded>} />
      <Route path="/audit" element={<Guarded><AuditLog /></Guarded>} />
    </Routes>
  );
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <AppRoutes />
          <Toaster position="top-right" richColors />
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
